import { type ITemplate } from '../interfaces';

export const doesTemplateHaveAtLeastOneOptionalDefinitionField = (template: ITemplate): boolean => {
  const {
    definition: { titlePlaceholder, subtitlePlaceholder, image, buttons },
  } = template;

  return Boolean(titlePlaceholder || subtitlePlaceholder || image || buttons);
};
